import { Segment } from '../../types';

export const top50Languages = [
  { name: 'English', code: 'en' },
  { name: 'Mandarin Chinese', code: 'zh-CN' },
  { name: 'Hindi', code: 'hi' },
  { name: 'Spanish', code: 'es' },
  { name: 'French', code: 'fr' },
  { name: 'Arabic', code: 'ar' },
  { name: 'Bengali', code: 'bn' },
  { name: 'Russian', code: 'ru' },
  { name: 'Portuguese', code: 'pt' },
  { name: 'Indonesian', code: 'id' },
  { name: 'Urdu', code: 'ur' },
  { name: 'German', code: 'de' },
  { name: 'Japanese', code: 'ja' },
  { name: 'Swahili', code: 'sw' },
  { name: 'Marathi', code: 'mr' },
  { name: 'Telugu', code: 'te' },
  { name: 'Turkish', code: 'tr' },
  { name: 'Tamil', code: 'ta' },
  { name: 'Yue Chinese (Cantonese)', code: 'zh-TW' },
  { name: 'Vietnamese', code: 'vi' },
  { name: 'Tagalog', code: 'tl' },
  { name: 'Korean', code: 'ko' },
  { name: 'Persian', code: 'fa' },
  { name: 'Hausa', code: 'ha' },
  { name: 'Thai', code: 'th' },
  { name: 'Italian', code: 'it' },
  { name: 'Gujarati', code: 'gu' },
  { name: 'Kannada', code: 'kn' },
  { name: 'Polish', code: 'pl' },
  { name: 'Malayalam', code: 'ml' },
  { name: 'Oriya', code: 'or' },
  { name: 'Burmese', code: 'my' },
  { name: 'Ukrainian', code: 'uk' },
  { name: 'Bhojpuri', code: 'bho' },
  { name: 'Punjabi', code: 'pa' },
  { name: 'Yoruba', code: 'yo' },
  { name: 'Maithili', code: 'mai' },
  { name: 'Uzbek', code: 'uz' },
  { name: 'Sindhi', code: 'sd' },
  { name: 'Amharic', code: 'am' },
  { name: 'Fula', code: 'ff' },
  { name: 'Romanian', code: 'ro' },
  { name: 'Oromo', code: 'om' },
  { name: 'Igbo', code: 'ig' },
  { name: 'Azerbaijani', code: 'az' },
  { name: 'Awadhi', code: 'awa' },
  { name: 'Greek', code: 'el' },
  { name: 'Somali', code: 'so' },
  { name: 'Malay', code: 'ms' },
  { name: 'Dutch', code: 'nl' },

  { name: 'Hebrew', code: 'he' },
  { name: 'Danish', code: 'da' },
  // What is the origin of this list?
] as const;

export type LanguageCode = typeof top50Languages[number]['code'];

export const translateText = async ({
  text,
  targetLang,
}: {
  text: string;
  targetLang: LanguageCode;
}) => {
  const sourceLang = 'auto'; // Automatically detect source language
  const googleTranslateUrl = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${encodeURIComponent(
    text
  )}`;

  try {
    const response = await fetch(googleTranslateUrl);
    const data = await response.json();
    const translatedResult = data[0].map((item: any[]) => item[0]).join('');
    return translatedResult;
  } catch (error) {
    console.error('Translation error:', error);
    return text;
  }
};

export const translateSegments = async (
  compactSegments: Segment[],
  targetLang: LanguageCode
) => {
  try {
    const translatedResults = await Promise.all(
      compactSegments.map(async (segment) => {
        const translatedText = await translateText({
          targetLang,
          text: segment.text,
        });
        return { ...segment, text: translatedText };
      })
    );
    return translatedResults;
  } catch (error) {
    console.error('Translation error:', error);
    throw error;
  }
};
